import { memo } from 'react';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

import resets from '../../../_resets.module.css';
import classes from './Button_ellipse.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
  text?:string;
  link?;
}
/* @figmaId 247:10 */
export const Button_ellipse: FC<Props> = memo(function Button_ellipse(props = {}) {
  const { t } = useTranslation();

  const location = useLocation(); // 現在のロケーションを取得
  const langCode = location.pathname.split('/')[1] || 'ja'; // URLから言語コードを取得 (デフォルトは 'ja')
  return (
    <Link to={`/${langCode}/${props.link}`} className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.root}`}>
      <div className={classes.text}>{props.text ||  t('common:button.details')}</div>
    </Link>
  );
});


